<template>
    <div class="header">
        <div class="logo">Rio.</div>
        <div class="burger" @click="showDrawer = true">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
        </div>
    </div>
    <transition name="slide">
        <div class="content-header" v-if="showDrawer">
            <div class="header-cont">
                <div class="logo-content">Rio.</div>
                <div class="burger-content" @click="showDrawer = false">
                    <div class="line-content"></div>
                    <div class="line-content"></div>
                </div>
            </div>
            <div class="link-list">
                <ul class="social-links">
                    <a href="https://www.facebook.com/riomartin.golimlim"
                        ><li><ion-icon name="logo-facebook"></ion-icon></li
                    ></a>
                    <a href="https://www.instagram.com/iogojar/"
                        ><li><ion-icon name="logo-instagram"></ion-icon></li
                    ></a>
                    <a href="https://x.com/golim_rio?t=oIeOOIbXCfkFEK8sCTPdvw&s=07"
                        ><li><ion-icon name="logo-twitter"></ion-icon></li
                    ></a>
                </ul>
                <div class="main-links">
                    <p
                        v-for="link in links"
                        :key="link.tab"
                        :class="{ active: link.tab == actTab }"
                        @click="changeTab(link.tab)"
                    >
                        {{ link.value }}
                    </p>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";
export default {
    setup() {
        const showDrawer = ref(false);
        const openDrawer = () => {};
        const store = useStore();
        const actTab = computed(() => store.state.activeTab);
        const links = [
            {
                tab: 0,
                value: "WHO",
            },
            {
                tab: 1,
                value: "WHY",
            },
            {
                tab: 2,
                value: "WHAT",
            },
            {
                tab: 3,
                value: "WORKS",
            },
        ];
        const changeTab = (tab) => {
            store.state.activeTab = tab;
            setTimeout(() => {
                showDrawer.value = false;
            }, 0);
        };
        return {
            openDrawer,
            showDrawer,
            links,
            actTab,
            changeTab,
        };
    },
};
</script>

<style lang="scss" scoped>
.header {
    background: #ecb365;
    height: 50px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
        color: #041c32;
        font-size: 30px;
        font-weight: bolder;
        margin-left: 10px;
    }
    .burger {
        margin-right: 10px;
        width: 32px;
        display: flex;
        flex-direction: column;
        gap: 4px;
        .line {
            height: 3px;
            border-radius: 5px;
            background: #fff;
        }
        .x {
            transform: rotate(45deg);
        }
        .x1 {
            transform: rotate(-45deg);
        }
    }
}
.content-header {
    position: fixed;
    background: #ecb365;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 9999;
    .header-cont {
        background: #041c32;
        height: 50px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .logo-content {
            color: #ecb365;
            font-size: 30px;
            font-weight: bolder;
            margin-left: 10px;
        }
        .burger-content {
            margin-right: 10px;
            width: 32px;
            display: flex;
            flex-direction: column;
            gap: 4px;
            position: relative;
            .line-content {
                height: 3px;
                width: 32px;
                border-radius: 5px;
                background: #fff;
                position: absolute;
                &:first-child {
                    transform: rotate(45deg);
                }
                &:last-child {
                    transform: rotate(-45deg);
                }
            }
        }
    }
    .link-list {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-align: center;
        margin-top: 20vw;
        gap: 10vw;
        .social-links {
            display: flex;
            list-style: none;
            gap: 2vw;
            a {
                text-decoration: none;
                color: #041c32;
                font-size: 2rem;
            }
        }
        .main-links {
            color: #041c32;
            font-size: 1.5rem;
            display: flex;
            flex-direction: column;
            gap: 5vw;
            .active {
                background: #eacaa0;
                padding: 1vw 25vw;
                border-radius: 20vw;
            }
        }
    }
}
</style>
